<ng-container *ngIf="destroyed$">
	<app-appointment-header
		[pageTitle]="pageTitle"
		[appointment]="appointment"
		[destroyed$]="destroyed$"
	></app-appointment-header>
</ng-container>

<ion-content>
	<ng-container *ngIf="!(isBlockingSync$ | async); else loader">
		<ion-router-outlet
			id="appointment-tabs"
			(activate)="onRouteActivate($event)"
		></ion-router-outlet>
	</ng-container>

	<ng-template #loader>
		<app-loader [message]="'Syncing'"></app-loader>
	</ng-template>
</ion-content>
